import { baseURL, defaultPostHeader } from '@/api/util'

export async function renewAccessToken(refresh_token: string): Promise<string | null> {
  try {
    const res = await fetch(`${baseURL}/auth/renew-access-token`, {
      method: 'POST',
      headers: defaultPostHeader,
      body: JSON.stringify({ refresh_token }),
      next: { revalidate: 0 },
      cache: 'no-store'
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d?.data)
  } catch {
    return Promise.resolve(null)
  }
}